var isScrolled = false;

export const scrollByFragment = () => {
	if (isScrolled)
		return;
	if (!document.getElementById)
		return;

	var hash = window.location.hash;
	if (!hash)
		return;

	var id = hash.slice(1);

	setTimeout(() => {
		var element = document.getElementById(id)
		if (element) 
			element.scrollIntoView();	
	}, 1000);
	

	isScrolled = true;
}